import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_left",
  "use": "chevron_left-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"chevron_left\"><path d=\"m4.59 9 5.71-5.71a.996.996 0 1 1 1.41 1.41L7.41 9l4.29 4.29a.996.996 0 1 1-1.41 1.41z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol